"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetQuestLeaderboardsResponseAllOfToJSON = exports.GetQuestLeaderboardsResponseAllOfFromJSONTyped = exports.GetQuestLeaderboardsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetQuestLeaderboardsResponseAllOfFromJSON(json) {
    return GetQuestLeaderboardsResponseAllOfFromJSONTyped(json, false);
}
exports.GetQuestLeaderboardsResponseAllOfFromJSON = GetQuestLeaderboardsResponseAllOfFromJSON;
function GetQuestLeaderboardsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'leaderboards': (json['leaderboards'].map(_1.QuestLeaderboardProfileFromJSON)),
    };
}
exports.GetQuestLeaderboardsResponseAllOfFromJSONTyped = GetQuestLeaderboardsResponseAllOfFromJSONTyped;
function GetQuestLeaderboardsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'leaderboards': (value.leaderboards.map(_1.QuestLeaderboardProfileToJSON)),
    };
}
exports.GetQuestLeaderboardsResponseAllOfToJSON = GetQuestLeaderboardsResponseAllOfToJSON;
